// extracted by mini-css-extract-plugin
export default {"divider":"componentEditor_divider__kM7e1"};